import React from 'react';
import { Link } from 'react-router-dom';

const MinimalLayout = ({ children }) => {
  return (
    <div className="minimal-layout">
      <nav className="minimal-nav">
        <div className="minimal-nav__container">
          <Link to="/" className="minimal-nav__logo">
            Andy Cary
          </Link>
          <div className="minimal-nav__links">
            <Link to="/nutrition-coaching" className="minimal-nav__link">
              Nutrition Coaching
            </Link>
          </div>
        </div>
      </nav>
      <main className="minimal-layout__content">
        {children}
      </main>
    </div>
  );
};

export default MinimalLayout; 